/**
 * Platform affordances that are cosmetic, never behavioural.
 *
 * The ⌘K handler accepts BOTH metaKey and ctrlKey on every platform; this only decides
 * which glyph the hint shows. jsdom's user agent is not a Mac, so tests deterministically
 * see `Ctrl`.
 */
export const IS_MAC = typeof navigator !== 'undefined' && /mac/i.test(navigator.userAgent);

export const MOD_KEY_LABEL = IS_MAC ? '⌘' : 'Ctrl ';
